/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 10 cm rotor at 10,000 RPM produces about 11,180 × g.`)
};

const es_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un rotor de 10 cm a 10.000 RPM produce unos 11.180 × g.`)
};

const de_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 10-cm-Rotor bei 10.000 RPM erzeugt etwa 11.180 × g.`)
};

const nl_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een rotor van 10 cm op 10.000 RPM levert ongeveer 11.180 × g op.`)
};

const fr_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un rotor de 10 cm à 10 000 RPM produit environ 11 180 × g.`)
};

const it_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un rotore da 10 cm a 10.000 RPM produce circa 11.180 × g.`)
};

const pt_br2_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um rotor de 10 cm a 10.000 RPM produz cerca de 11.180 × g.`)
};

const pt_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um rotor de 10 cm a 10 000 RPM produz cerca de 11 180 × g.`)
};

const ja_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半径10cmのローターを10,000 RPMで回すと、約11,180 × gになります。`)
};

const zh_gf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 cm 转子在 10,000 RPM 下产生约 11,180 × g。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_ex1", locale)
	if (locale === "en") return en_gf_ex1(inputs)
	if (locale === "es") return es_gf_ex1(inputs)
	if (locale === "de") return de_gf_ex1(inputs)
	if (locale === "nl") return nl_gf_ex1(inputs)
	if (locale === "fr") return fr_gf_ex1(inputs)
	if (locale === "it") return it_gf_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_gf_ex1(inputs)
	if (locale === "pt") return pt_gf_ex1(inputs)
	if (locale === "ja") return ja_gf_ex1(inputs)
	return zh_gf_ex1(inputs)
};